<template>
    <div
        class="custom-select relative"
        :tabindex="tabindex"
        v-click-outside="closeDropdown"
    >
        <div
            class="selected whitespace-nowrap overflow-hidden !text-gray-700"
            :class="{ open: open }"
            @click="open = !open"
        >
            {{ selected ? selected[optionLabel] : selectLabel }}
        </div>
        <div class="items max-w-md w-full !bg-gray-100" :class="{ selectHide: !open }">
            <div class="disabled" v-if="!disableSelectLabel">
                {{ selectLabel }}
            </div>
            <input
                type="text"
                class="border-0 h-8 w-full text-sm"
                placeholder="Search ..."
                v-model="searchQuery"
            />
            <a
                href="#"
                v-if="searchQuery.length > 1"
                @click.prevent="searchQuery = ''"
                class="absolute top-1 right-3 text-2xl text-slate-500"
                role="button"
                >&times;</a
            >
            <div
                v-for="(option, i) of filteredOptions"
                :key="i"
                class="whitespace-nowrap"
                :class="{
                    selecteditem: valueDefault[valueKey]
                        ? option[selectedValueKey] === valueDefault[valueKey]
                        : false,
                }"
                @click="
                    select = option;
                    open = false;
                    $emit('input', {
                        value: valueDefault,
                        value_key: valueKey,
                        selected_value: option,
                        selected_value_key: selectedValueKey,
                    });
                "
            >
                {{ option[optionLabel] }}
            </div>
        </div>
    </div>
</template>

<script>
import { matchSorter } from "match-sorter";
import vClickOutside from "click-outside-vue3";

export default {
    props: {
        options: {
            type: Array,
            required: true,
        },
        selectLabel: {
            type: String,
            required: true,
        },
        disableSelectLabel: {
            type: Boolean,
            default: false,
        },
        valueKey: {
            type: String,
            required: true,
        },
        selectedValueKey: {
            type: String,
            required: true,
        },
        optionLabel: {
            type: String,
            required: true,
        },
        valueDefault: {
            type: Object,
            required: false,
            default: null,
        },
        tabindex: {
            type: Number,
            required: false,
            default: 0,
        },
    },
    directives: {
        ClickOutside: vClickOutside.directive,
    },
    data() {
        return {
            open: false,
            select: "",
            searchQuery: "",
        };
    },
    computed: {
        selected() {
            return this.options.filter((obj) => {
                return (
                    obj[this.selectedValueKey] ===
                    this.valueDefault[this.valueKey]
                );
            })[0];
        },
        filteredOptions() {
            const localQuery = this.searchQuery
                .toLowerCase()
                .replace(/[^a-zA-Z\d\s:]/g, "");

            let options = matchSorter(this.options, localQuery, {
                keys: ["title"],
            });

            return options;
        },
    },
    methods: {
        closeDropdown() {
            this.open = false;
        },
    },
    mounted() {
        //this.$emit('input', this.selected);
    },
};
</script>

<style lang="scss" scoped>
.custom-select {
    position: relative;
    width: 100%;
    text-align: left;
    outline: none;
    height: 47px;
    line-height: 47px;
}

.custom-select .selected {
    background-color: #fff;
    border: none;
    border-bottom: 2px solid #fd411d;
    color: #afb9c6;
    padding: 0 1.75em 0 1em;
    cursor: pointer;
    user-select: none;

    &:after {
        display: block;
        content: "\f107";
        font-family: "Font Awesome 6 Pro";
        font-size: 20px;
        line-height: 1.6;
        position: absolute;
        right: 24px;
        bottom: 4px;
        color: #fd411d;
        pointer-events: none;
    }
}

.custom-select .items {
    min-width: 260px;
    max-height: 300px;
    overflow: auto;
    color: #122c36;
    border-radius: 6px;
    border: 1px solid #e1e8f1;
    position: absolute;
    background-color: #ffffff;
    top: 110%;
    left: 0;
    z-index: 100;
}

.custom-select .items div {
    color: #122c36;
    padding: 1em;
    font-size: 14px;
    line-height: 1.4;
    cursor: pointer;
    user-select: none;
    border-bottom: 1px solid #e1e8f1;
    position: relative;

    &:last-child {
        border: none;
    }

    &.disabled {
        cursor: normal;
        color: #afb9c6;
        background-color: #fff;
    }

    &.selecteditem {
        background-color: #f8fafc;

        &:after {
            display: block;
            content: "\f00c";
            font-family: "Font Awesome 6 Pro";
            font-size: 16px;
            line-height: 1.6;
            position: absolute;
            right: 24px;
            bottom: 10px;
            color: #fd411d;
            pointer-events: none;
        }
    }
}

.custom-select .items div:hover {
    background-color: #f8fafc;

    &.disabled {
        color: #afb9c6;
        background-color: #fff;
    }
}

.selectHide {
    display: none;
}
</style>
